/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { StockLedgerService } from "services/stock-ledger";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    const totalQty =
      item.details?.reduce((sum, it) => sum + (parseFloat(it.actualQuantity) || 0), 0) || 0;
    const totalAmount = formatCurrency.format(
      item.details?.reduce((sum, it) => sum + (parseFloat(it.totalAmount) || 0), 0) || 0
    );
    const licenceDate = item.licenceDate
      ? new Date(item.licenceDate).toLocaleDateString("vi-VN")
      : "";

    return {
      id: item._id,
      unit: item.unit || "",
      licenceNumber: item.licenceNumber || "",
      year: item.year || "",
      company: item.company?.name || "N/A",
      regQty: item.registeredQuantity || 0,
      regParVal: formatCurrency.format(item.registeredParValue || 0),
      licenceDate,
      totalQty,
      totalAmount,
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    { Header: "Đơn vị", accessor: "unit", width: "15%" },
    { Header: "Số GPLĐ", accessor: "licenceNumber", width: "15%" },
    { Header: "Năm", accessor: "year", width: "8%" },
    { Header: "Công ty", accessor: "company", width: "15%" },
    { Header: "SL đăng ký", accessor: "regQty", width: "10%" },
    { Header: "Mệnh giá ĐK", accessor: "regParVal", width: "12%" },
    { Header: "Ngày GPLĐ", accessor: "licenceDate", width: "10%" },
    { Header: "Tổng SL", accessor: "totalQty", width: "10%" },
    { Header: "Tổng TT", accessor: "totalAmount", width: "12%" },
    { Header: "Ngày tạo", accessor: "createdAt", width: "10%" },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function StockLedger() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await StockLedgerService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ Chi Tiết Phát Hành Cổ Phiếu (S43-DN):", error);

      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default StockLedger;
